module.exports = __webpack_public_path__ + "static/media/untappd.acf79cbe.svg";